import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
	NgbDropdownModule,
	NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { MatSelectInfiniteScrollDirective } from '../../../core/directives';
import { SearchModule } from '../../../global/search/search.module';
import { CampaignIndexComponent } from './campaign-index.component';
import { FilterInListOfCampaignComponent } from './component/filter-in-list-of-campaign';
import { ViewingListOfCampaignTableComponent } from './component/viewing-list-of-campaign-table';

@NgModule({
	declarations: [
		ViewingListOfCampaignTableComponent,
		FilterInListOfCampaignComponent,
		CampaignIndexComponent,
		MatSelectInfiniteScrollDirective,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatDatepickerModule,
		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		MatDialogModule,
		MatTabsModule,
		MatCardModule,
		MatCheckboxModule,
		MatSelectModule,
		MatRadioModule,
		MatButtonModule,
		MatIconModule,
		MatChipsModule,
		NgbPaginationModule,
		NgbDropdownModule,
		MatChipsModule,
		MatGridListModule,
		MatNativeDateModule,
		SearchModule,
		MatToolbarModule,
		MatTooltipModule,
	],
	exports: [CampaignIndexComponent, MatSelectInfiniteScrollDirective],
})
export class CampaignIndexModule {}
